import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../../components/icon/Icon';
import './Search.scss';

interface SearchProps {
  ariaLabel?: undefined | string;
  handleSearch: (e: string) => void;
  placeholder: string;
}

export const Search: React.FC<SearchProps> = ({
  ariaLabel,
  handleSearch,
  placeholder
}) => {
  const [searchText, setSearchText] = useState('');
  const [isActive, setIsActive] = useState(false);
  const [placeholderColor, setPlaceholderColor] = useState(false);
  const node = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (searchText !== '') {
      setIsActive(true);
    }
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [isActive, placeholderColor, searchText]);

  const handleClick = (e: any) => {
    if (null !== node.current) {
      if (node.current.contains(e.target)) {
        return;
      } else if (isActive) {
        if (searchText === '') {
          setIsActive(false);
        }
      } else if (placeholderColor) {
        setPlaceholderColor(false);
      }
    }
  };

  return (
    <div
      className="ads-search"
      role="search"
      aria-label={ariaLabel}
      data-testid="ads-search"
    >
      <input
        className={`ads-search__input ${
          placeholderColor ? 'ads-search__placeholder' : ''
        }`}
        type="text"
        tabIndex={0}
        placeholder={placeholder}
        value={searchText}
        ref={node}
        data-testid="ads-search__input"
        onClick={() => setPlaceholderColor(true)}
        onChange={(e) => setSearchText(e.target.value)}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.key === 'Enter') {
            if (searchText !== '') {
              handleSearch(searchText);
            }
          }
        }}
        onMouseDown={(e) => {
          if (e.type === 'mousedown') {
            e.currentTarget.blur();
          }
        }}
      />
      <span
        className={`${isActive ? 'ads-search__clear' : 'ads-search__remove'}`}
        tabIndex={isActive ? 0 : -1}
        ref={node}
        data-testid="ads-search__clear"
        onClick={() => {
          setSearchText('');
          setIsActive(!isActive);
          setPlaceholderColor(!placeholderColor);
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLSpanElement>) => {
          if (e.key === ' ') {
            if (searchText !== '') {
              setSearchText('');
              setIsActive(!isActive);
              setPlaceholderColor(!placeholderColor);
            }
          }
        }}
      >
        <Icon name="closeLg" color="ads-color-icon-02" />
      </span>
      <span className="ads-search--container">
        <span
          className="ads-search__search"
          tabIndex={isActive ? 0 : -1}
          data-testid="ads-search__search-button"
          onClick={() => {
            if (searchText !== '') {
              handleSearch(searchText);
            }
          }}
          onKeyDown={(e: React.KeyboardEvent<HTMLSpanElement>) => {
            if (e.key === ' ' || e.key === 'Enter') {
              if (searchText !== '') {
                handleSearch(searchText);
              }
            }
          }}
        >
          <span className="ads-search__search--focus">
            <Icon name="search" color="ads-color-inverse" />
          </span>
        </span>
      </span>
    </div>
  );
};
